// extracted by mini-css-extract-plugin
module.exports = {"container":"gHZpeN","content":"_1EwAMv","primaryMessage":"_196Teg","actions":"_27nbZ2","secondaryAction":"wZP3sz"};